import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Listfarmer, FarmerDelete, FarmerBulkDelete } from '../store/slices/farmer.js';
import Loader from '../common/Loader';
import { useDispatch, useSelector } from 'react-redux';
import Table from '../common/Table';
import AdminLayout from './AdminLayout';
import UploadFarmersPopup from './UploadFarmersPopup';
import { toast } from 'react-hot-toast';
import { FaFileExcel } from 'react-icons/fa';
import { Farmers } from '../common/ExcelDownload';

const DirectorsMaster = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const tableRef = useRef(null);

  const user = JSON.parse(localStorage.getItem('user'));
  const id = user?.data?.profile_id;

  const [isLoading, setIsLoading] = useState(false);
  const [listfarmer, setListfarmer] = useState([]);
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]); // Stores selected row IDs
  const [selectAll, setSelectAll] = useState(false);
  const [columns, setcolumns] = useState([
    { header: 'Checkbox', field: 'Checkbox' },
    { header: 'Name', field: 'name' },
    { header: 'Address', field: 'address' },
    { header: 'Email', field: 'email' },
    { header: 'Phone', field: 'phone' },
    { header: 'Date', field: 'date_added' },
    {
      header: 'Actions',
      field: 'actions',
      isAction: true,
      actionButtons: [
        { name: 'Edit', className: 'btn-default' },
        { name: 'Delete', className: 'btn-cancel' },
      ],
    },
  ]);

  const [pageSize, setPageSize] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleEdit = (item) => {
    navigate(`/farmer/edit/${item.id ? item.id : null}`);
  };

  const fetchListfarmer = async () => {
    setIsLoading(true);
    dispatch(Listfarmer({ profile_id: id }))
      .unwrap()
      .then((data) => {
        setIsLoading(false);
        setListfarmer(data?.data);
      })
      .catch(({ message }) => {
        setIsLoading(false);
        setListfarmer([]);
        console.log(message);
      });
  };

  React.useEffect(() => {
    fetchListfarmer();
  }, [dispatch]);

  const handleDelete = (item) => {
    const confirmDelete = window.confirm('Are you sure you want to delete this Farmer?');
    if (confirmDelete) {
      setIsLoading(true);
      dispatch(FarmerDelete({ id: item.id, profile_id: id }))
        .unwrap()
        .then(() => {
          setIsLoading(false);
          fetchListfarmer(); // Refresh the invoice list
        })
        .catch(({ message }) => {
          // console.log(message)
          setIsLoading(false);
          toast.error(message);
        });
    }
  };

  const handleDeleteBulk = () => {
    console.log("selectedRows",selectedRows)
    if (!selectedRows || selectedRows?.length === 0) {
      alert('Please select at least one Farmers.');
      return;
    }

    if (selectedRows.length === 0) {
      alert('No matching Farmers found.');
      return;
    }

    console.log(selectedRows)
    const confirmDelete = window.confirm('Are you sure you want to delete these Farmers?');
    if (confirmDelete) {
      setIsLoading(true);
      dispatch(FarmerBulkDelete({ ids:selectedRows, profile_id: id }))
        .unwrap()
        .then(() => {
          setIsLoading(false);
          fetchListfarmer(); // Refresh the invoice list
        })
        .catch(({ message }) => {
          // console.log(message)
          setIsLoading(false);
          toast.error(message);
        });
    }
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleOpenPopup = () => {
    setPopupOpen(true);
  };

  // Function to close the popup
  const handleClosePopup = () => {
    setPopupOpen(false);
  };

  const handleUploadSuccess = () => {
    console.log('File uploaded successfully!');
    setPopupOpen(false); // Close the popup after upload
    fetchListfarmer();
  };

  // Filter data based on search query
  const filteredParties = listfarmer?.filter(
    (party) =>
      party?.name?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
      party?.address?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
      party?.email?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
      party?.phone?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
      party?.date_added?.toLowerCase()?.includes(searchQuery?.toLowerCase())
  );


   const handleExcelDownload = () => {
      const selectedInvoices = selectAll ? listfarmer.map((invoice) => invoice.id) : selectedRows;
  
      if (!selectedInvoices || selectedInvoices.length === 0) {
        alert('Please select at least one Farmers.');
        return;
      }
  
      const selectedData = listfarmer.filter((invoice) => selectedInvoices.includes(invoice.id));
  
      if (selectedData.length === 0) {
        alert('No matching Farmers found.');
        return;
      }
  
      try {
        Farmers(selectedData, 'Farmers.xlsx');
        toast.success('Downloading Excel file successfully!');
      } catch (error) {
        console.error('Error downloading Excel file:', error);
        alert('Failed to download the Excel file. Please try again.');
      }
    };

  return (
    <AdminLayout>
      {isLoading && <Loader />}
      <div className="row content-body">
        <div className="container-fluid">
          <div className="page-header">
            <div>
              <h2 className="main-content-title tx-24 mg-b-5">Farmer's Master</h2>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="#">Farmer's Master</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Farmer's List
                </li>
              </ol>
            </div>
            <div className="d-flex justify-content-end">
             <button className="btn ripple btn-default" onClick={handleExcelDownload}>
                            Export Excel <FaFileExcel />
              </button>
              <button className="btn ripple btn-cancel" onClick={() => handleDeleteBulk()}>
                Delete Farmers
              </button>
              <button className="btn ripple btn-default" onClick={() => handleOpenPopup()}>
                Import Farmer
              </button>
              <button className="btn ripple btn-default" onClick={() => navigate('/farmer/create')}>
                Add Farmer
              </button>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <Table
                columns={columns}
                data={filteredParties}
                tableRef={tableRef}
                pageSize={pageSize}
                setPageSize={setPageSize}
                currentPage={currentPage}
                totalCount={filteredParties?.length}
                onPageChange={handlePageChange}
                handleEdit={handleEdit}
                handleDelete={handleDelete}
                handleSearchChange={handleSearchChange}
                selectedRows={selectedRows}
                setSelectedRows={setSelectedRows}
                selectAll={selectAll}
                setSelectAll={setSelectAll}
              />
            </div>
          </div>
        </div>
      </div>
      <UploadFarmersPopup open={isPopupOpen} onClose={handleClosePopup} onUpload={handleUploadSuccess} />
    </AdminLayout>
  );
};

export default DirectorsMaster;
